// extracted by mini-css-extract-plugin
export default {"scrollable-content":"ViewCurrencyDetails_scrollable-content__U4PsN","card":"ViewCurrencyDetails_card__38jo6","ant-card-head-title":"ViewCurrencyDetails_ant-card-head-title__z99uW"};